module.exports = __webpack_public_path__ + "static/img/ten.c564849.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/ten.png
// module id = yE1e
// module chunks = 2